import { ContentStateInterface } from '../../../../../../@types/types'
import { ApiSiteRecommendedUseTypes } from '../../../../../../@types/real-estate-api-types'

export const siteRecommendedUseTypesToApi = (insertionData: ContentStateInterface): ApiSiteRecommendedUseTypes => ({
  NO_INFORMATION: insertionData.siteRecommendedUseTypes?.noInformation ?? false,
  FUTURE_DEVELOPMENT_LAND: insertionData.siteRecommendedUseTypes?.futureDevelopmentLand ?? false,
  TWINHOUSE: insertionData.siteRecommendedUseTypes?.twinHouse ?? false,
  SINGLE_FAMILY_HOUSE: insertionData.siteRecommendedUseTypes?.singleFamilyHouse ?? false,
  GARAGE: insertionData.siteRecommendedUseTypes?.garage ?? false,
  GARDEN: insertionData.siteRecommendedUseTypes?.garden ?? false,
  NO_DEVELOPMENT: insertionData.siteRecommendedUseTypes?.noDevelopment ?? false,
  APARTMENT_BUILDING: insertionData.siteRecommendedUseTypes?.apartmentBuilding ?? false,
  ORCHARD: insertionData.siteRecommendedUseTypes?.orchard ?? false,
  TERRACE_HOUSE: insertionData.siteRecommendedUseTypes?.terraceHouse ?? false,
  PARKING_SPACE: insertionData.siteRecommendedUseTypes?.parkingSpace ?? false,
  VILLA: insertionData.siteRecommendedUseTypes?.villa ?? false,
  FORREST: insertionData.siteRecommendedUseTypes?.forrest ?? false,
  LITTLE_STORE: insertionData.siteRecommendedUseTypes?.littleStore ?? false,
  GASTRONOMY: insertionData.siteRecommendedUseTypes?.gastronomy ?? false,
  BUSINESS: insertionData.siteRecommendedUseTypes?.business ?? false,
  HOTEL: insertionData.siteRecommendedUseTypes?.hotel ?? false,
  INDUSTRY: insertionData.siteRecommendedUseTypes?.industry ?? false,
  SMALL_BUSINESS: insertionData.siteRecommendedUseTypes?.smallBusiness ?? false,
  STOCK: insertionData.siteRecommendedUseTypes?.stock ?? false,
  CAR_PARK: insertionData.siteRecommendedUseTypes?.carPark ?? false,
  PRODUCTION: insertionData.siteRecommendedUseTypes?.production ?? false,
  FARMLAND: insertionData.siteRecommendedUseTypes?.farmland ?? false,
  MOORAGE: insertionData.siteRecommendedUseTypes?.moorage ?? false,
  OFFICE: insertionData.siteRecommendedUseTypes?.office ?? false,
  CAMPING: insertionData.siteRecommendedUseTypes?.camping ?? false,
  BIG_STORE: insertionData.siteRecommendedUseTypes?.bigStore ?? false,
})
